import {CUSTOMER, NewSubAccount, SUPPLIER} from '@/subaccount/types/SubAccount'
import {Address} from '@/subaccount/types/Address'
import {ContactInfo} from '@/subaccount/types/ContactInfo'

export const defaultSubAccount = () => {
    return {
        isBusiness: true,
        orgNo: '',
        name: '',
        contactInfo: defaultContactInfo(),
        address: defaultAddress(),
        metadata: {suggestions: {expenseAccount: ''}},
        notes: '',
        active: true
    }
}

export const defaultNewCustomer = () => {
    return {
        relationType: CUSTOMER,
        ...defaultSubAccount(),
        customerDebtCollectionSettings: defaultDebtCollectionSettings()
    } as NewSubAccount
}

export const defaultNewSupplier = () => {
    return {
        relationType: SUPPLIER,
        ...defaultSubAccount()
    }
}

export const defaultAddress = (): Address => {
    return {
        addressLine: '',
        postalCode: '',
        postalLocation: '',
        countryCode: 'NO' // Default to Norway
    }
}

export const defaultContactInfo = (): ContactInfo => {
    return {
        name: '',
        email: '',
        phoneNumber: ''
    }
}

const defaultDebtCollectionSettings = () => {
    return {
        customerSettingsEnabled: false,
        reminderType: 'PAYMENT_REMINDER',
        intervalDays: 14
    }
}